import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {DbStoreState} from "../../../../store";
import {Store} from '@ngrx/store';
import {RouteDataService} from "../../../../shared/services/route-data/route-data.service";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import * as fromStore from "../../../../store";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../../../../user/user";
import {Subject} from "rxjs";
import {AuthService} from "../../../../auth/auth.service";
import blocksInfo from "./setup-blocks-info.json";

@Component({
    selector: 'db-create',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.scss'],
    standalone: false
})
export class CreateComponent implements OnInit, OnDestroy {

  public pageId;
  public user: User;
  public blocks = blocksInfo;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<DbStoreState>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _routeDataService: RouteDataService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _authService: AuthService
  ) {}

  ngOnInit() {
    this.pageId = this._routeDataService.getCurrentRouteData().pageId;
    this.routerEvents();
    this.getUser();
  }

  public routerEvents(): void {
    this._router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.pageId = this._router && this._router.url.split("/").pop();
      });
  }

  public getUser(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser)),
        filter((user: User) => !!user),
        takeUntil(this._destroyStream$)
      )
      .subscribe((user: User) => {
        this.user = user;
      });
  }
  public goToNextStep(url) {
    if (this.user && this.user.signUpFor) {
      this.user.signUpFor['LastChosenOption'] = {answer: url, id: ''};
      this._authService.updateSignUpFor(this.user.signUpFor, true);
    }

    this.choseStepEvent(url);
    this._router.navigate([url], {relativeTo: this._route});
  }

  public choseStepEvent(url): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Create a Website',
      eventLabel: url
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
